exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay-menu .nav-section[data-v-4357408d]{text-align:center;font-weight:700;padding:1.5rem 0 .5rem}.overlay-menu .nav-link[data-v-4357408d]{text-align:center;font-weight:400;font-size:.875rem;padding:.375rem 0}.overlay-menu .nav-link.active[data-v-4357408d]{font-weight:700;color:#28807c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4357408d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?outputStyle=expanded!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = GjjZ
// module chunks = 1